module.exports = __webpack_public_path__ + "img/SOCIOLOGIA.133914e4.png";